<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/gaji-periode">Daftar Periode Penggajian</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Riwayat Gaji
        </li>
      </ol>
    </nav>
    <LogPopupTemplate ref="logPopup" />

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Cari Nama:</p>
        <div class="row">
          <!-- <div class="editors"> -->
          <div class="editors-container">
            <div class="col">
              <DxTextBox
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                label="Cari nama"
                placeholder="nama"
                v-model="cariNamaPegawai"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxTextBox>
            </div>

            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="cariPegawai"
                text="Cari"
                styling-mode="filled"
                type="default"
                class="validate"
                style="float: left"
              />
            </div>
            <div class="col" style="padding-left: 10px">
              <DxButton
                icon="remove"
                @click="resetFilter()"
                text="Hilangkan semua pencarian"
                type="danger"
                style="float: right"
                styling-mode="outlined"
              ></DxButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <!-- <div>
          <p>
            <strong>DOUBLE CLICK</strong> pada baris tabel untuk menandai gaji
            adalah <strong>SALAH</strong> (hanya dapat dilakukan oleh user
            Pejabat)
          </p>
        </div> -->
        <DxTabPanel
          id="tabpanel"
          :data-source="tabSource"
          v-model:selected-index="tabPanelIndex"
          :loop="loop"
          :animation-enabled="animationEnabled"
          :swipe-enabled="swipeEnabled"
          item-title-template="title"
          @titleClick="tabTitleClick"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <!-- gajiListStore.dataSourceGajiList.filter([
                  'gajis_pegawai_status_id',
                  '=',
                  1,
                ]) -->

          <template #tDireksi>
            <!--  -->
            <!-- :data-source="direksiStore" -->
            <DxDataGrid
              ref="gridRefDireksi"
              id="gridTDireksi"
              :data-source="gajiListStore.dataSourceGajiDireksiHistory"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefDireksi')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              @row-updating="onRowUpdating($event, 'gridRefDireksi')"
              :filter-value="filterValue"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefDireksi')
              "
              :filter-sync-enabled="true"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <!-- <DxFilterRow :visible="true" :apply-filter="currentFilter" /> -->
              <!-- <dx-pager :show-page-size-selector="true" :show-info="true" /> -->
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              />

              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefDireksi')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>

              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />

              <DxColumn
                :visible="false"
                class="noteditable"
                data-type="boolean"
                data-field="tandai_salah"
                caption="Tandai Salah HALO"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #headerTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderExpand"
                  />
                  <span style="margin-left: 8px">Pekerjaan</span>
                </div>
              </template>
              <template #headerGajiTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpandedGaji ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderGajiExpand"
                  />
                  <span style="margin-left: 8px">Gaji</span>
                </div>
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="200"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                data-field="tgl_gaji"
                caption="Periode Penggajian"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :filter-operations="filterOperations"
                :fixed="true"
                fixed-position="left"
              />

              <DxColumn
                :allow-hiding="false"
                class="noteditable"
                data-field="golongans_nama"
                caption="Gol."
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.getGolonganSource().value,
                }"
              />

              <DxColumn
                data-field="ptkp"
                caption="PTKP"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusPtkpSource }"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="ter"
                caption="TER PPH 21(%)"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                data-type="number"
              />

              <DxColumn
                caption="Pekerjaan"
                header-cell-template="headerTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="cabangs_nama"
                  caption="Cabang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.cabangSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="units_nama"
                  caption="Unit"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.unitSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="jabatans_nama"
                  caption="Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.jabatanSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bagians_nama"
                  caption="Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bagianSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bagians_nama"
                  caption="Sub Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bidangs_nama"
                  caption="Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bidangs_nama"
                  caption="Sub Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="seksis_nama"
                  caption="Seksi"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.seksiSource }"
                  :visible="isExpanded"
                />
              </DxColumn>
              <DxColumn
                caption="Gaji"
                header-cell-template="headerGajiTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  class="noteditable-gaji"
                  :allowHeaderFiltering="false"
                  data-type="number"
                  data-field="gaji_pokok"
                  caption="Gaji Pokok"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_perusahaan"
                  caption="Tunj. Perusahaan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_jabatan"
                  caption="Tunj. Jabatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kemahalan"
                  caption="Tunj. Kemahalan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_air"
                  caption="Tunj. Air"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_transport"
                  caption="Tunj. Transport"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_pangan"
                  caption="Tunj. Pangan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kesehatan"
                  caption="Tunj. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkk"
                  caption="Premi JKK"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkm"
                  caption="Premi JKM"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  data-field="absen_bulans_tidak_hadir"
                  caption="Jml Tdk Hadir"
                  class="noteditable"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_5_persen"
                  caption="Pot. Tdk Hadir"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="jml_bruto"
                  caption="Jml Bruto"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="tun_pph"
                  caption="Tunj. PPH"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_kesehatan"
                  caption="Pot. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_tiga_program"
                  caption="Pot. BPJS TK 3 Program"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_empat_program"
                  caption="Pot. BPJS TK 4 Program"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_pensiun"
                  caption="Pot. Pensiun IFG LIFE"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="ifg_mandiri"
                  caption="Pot. IFG Mandiri"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_pph"
                  caption="Pot. PPH"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
              </DxColumn>
              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
                :min-width="150"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>

              <!-- <DxColumn
                :allow-hiding="false"
                class="noteditable"
                data-field="golongans_nama"
                caption="Gol."
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.getGolonganSource().value,
                }"
              /> -->

              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>

              <DxSummary>
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkk"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkm"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="absen_bulans_tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="ifg_mandiri"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
          <template #tTetap>
            <DxDataGrid
              ref="gridRefTetap"
              id="gridTetap"
              :data-source="gajiListStore.dataSourceGajiTetapHistory"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefTetap')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @row-updating="onRowUpdating($event, 'gridRefTetap')"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefTetap')
              "
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <DxExport :enabled="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
              />

              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefTetap')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>

              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />

              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #headerTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderExpand"
                  />
                  <span style="margin-left: 8px">Pekerjaan</span>
                </div>
              </template>
              <template #headerGajiTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpandedGaji ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderGajiExpand"
                  />
                  <span style="margin-left: 8px">Gaji</span>
                </div>
              </template>

              <!-- <DxColumn
                data-type="number"
                class="noteditable"
                data-field="id"
                caption="GAJIID"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              /> -->

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="200"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                data-field="tgl_gaji"
                caption="Periode Penggajian"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :filter-operations="filterOperations"
                :fixed="true"
                fixed-position="left"
              />

              <DxColumn
                :allow-hiding="false"
                class="noteditable"
                data-field="golongans_nama"
                caption="Gol."
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.getGolonganSource().value,
                }"
              />

              <!-- <DxColumn
                class="noteditable"
                data-field="riwayatGolongan.golongan_id"
                caption="Gol."
              >
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn> -->

              <DxColumn
                data-field="ptkp"
                caption="PTKP"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusPtkpSource }"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable"
                data-field="ter"
                caption="TER PPH 21(%)"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                data-type="number"
              />

              <DxColumn
                caption="Pekerjaan"
                header-cell-template="headerTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="cabangs_nama"
                  caption="Cabang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.cabangSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="units_nama"
                  caption="Unit"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.unitSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="jabatans_nama"
                  caption="Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.jabatanSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bagians_nama"
                  caption="Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bagians_nama"
                  caption="Sub Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bidangs_nama"
                  caption="Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bidangs_nama"
                  caption="Sub Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="seksis_nama"
                  caption="Seksi"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.seksiSource }"
                  :visible="isExpanded"
                />
              </DxColumn>
              <DxColumn
                caption="Gaji"
                header-cell-template="headerGajiTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="gaji_pokok"
                  caption="Gaji Pokok"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_perusahaan"
                  caption="Tunj. Perusahaan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_jabatan"
                  caption="Tunj. Jabatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kemahalan"
                  caption="Tunj. Kemahalan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_air"
                  caption="Tunj. Air"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_transport"
                  caption="Tunj. Transport"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_pangan"
                  caption="Tunj. Pangan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kesehatan"
                  caption="Tunj. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkk"
                  caption="Premi JKK"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkm"
                  caption="Premi JKM"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  data-field="absen_bulans_tidak_hadir"
                  caption="Jml Tdk Hadir"
                  class="noteditable"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_5_persen"
                  caption="Pot. Tdk Hadir"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="jml_bruto"
                  caption="Jml Bruto"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="tun_pph"
                  caption="Tunj. PPH"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_kesehatan"
                  caption="Pot. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_tiga_program"
                  caption="Pot. BPJS TK 3 Program"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_empat_program"
                  caption="Pot. BPJS TK 4 Program"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_pensiun"
                  caption="Pot. Pensiun IFG LIFE"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="ifg_mandiri"
                  caption="Pot. IFG Mandiri"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_pph"
                  caption="Pot. PPH"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
              </DxColumn>
              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :min-width="150"
                :allow-hiding="false"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="true"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>

              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>

              <DxSummary>
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkk"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkm"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absen_bulans_tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="ifg_mandiri"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>

          <template #tCapeg>
            <DxDataGrid
              ref="gridRefCapeg"
              id="gridTetap"
              :data-source="gajiListStore.dataSourceGajiCapegHistory"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefCapeg')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @row-updating="onRowUpdating($event, 'gridRefCapeg')"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefCapeg')
              "
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <DxExport :enabled="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
              />

              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefCapeg')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>

              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />

              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #headerTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderExpand"
                  />
                  <span style="margin-left: 8px">Pekerjaan</span>
                </div>
              </template>
              <template #headerGajiTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpandedGaji ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderGajiExpand"
                  />
                  <span style="margin-left: 8px">Gaji</span>
                </div>
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="200"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                data-field="tgl_gaji"
                caption="Periode Penggajian"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :filter-operations="filterOperations"
                :fixed="true"
                fixed-position="left"
              />

              <DxColumn
                :allow-hiding="false"
                class="noteditable"
                data-field="golongans_nama"
                caption="Gol."
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.getGolonganSource().value,
                }"
              />

              <DxColumn
                data-field="ptkp"
                caption="PTKP"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusPtkpSource }"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="ter"
                caption="TER PPH 21(%)"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                data-type="number"
              />
              <DxColumn
                caption="Pekerjaan"
                header-cell-template="headerTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="cabangs_nama"
                  caption="Cabang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.cabangSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="units_nama"
                  caption="Unit"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.unitSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="jabatans_nama"
                  caption="Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.jabatanSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bagians_nama"
                  caption="Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bagians_nama"
                  caption="Sub Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bidangs_nama"
                  caption="Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bidangs_nama"
                  caption="Sub Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="seksis_nama"
                  caption="Seksi"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.seksiSource }"
                  :visible="isExpanded"
                />
              </DxColumn>

              <DxColumn
                caption="Gaji"
                header-cell-template="headerGajiTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="gaji_pokok"
                  caption="Gaji Pokok"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_perusahaan"
                  caption="Tunj. Perusahaan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_jabatan"
                  caption="Tunj. Jabatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kemahalan"
                  caption="Tunj. Kemahalan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_air"
                  caption="Tunj. Air"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_transport"
                  caption="Tunj. Transport"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_pangan"
                  caption="Tunj. Pangan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kesehatan"
                  caption="Tunj. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkk"
                  caption="Premi JKK"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkm"
                  caption="Premi JKM"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  data-field="absen_bulans_tidak_hadir"
                  caption="Jml Tdk Hadir"
                  class="noteditable"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_5_persen"
                  caption="Pot. Tdk Hadir"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="jml_bruto"
                  caption="Jml Bruto"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="tun_pph"
                  caption="Tunj. PPH"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_kesehatan"
                  caption="Pot. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_tiga_program"
                  caption="Pot. BPJS TK 3 Program"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_empat_program"
                  caption="Pot. BPJS TK 4 Program"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_pensiun"
                  caption="Pot. Pensiun IFG LIFE"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="ifg_mandiri"
                  caption="Pot. IFG Mandiri"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_pph"
                  caption="Pot. PPH"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
              </DxColumn>

              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :min-width="150"
                :allow-hiding="false"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="true"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>
              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>

              <DxSummary>
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkk"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkm"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absen_bulans_tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="ifg_mandiri"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>

          <template #tHonor>
            <!-- 
            :focused-row-index="0" -->
            <DxDataGrid
              ref="gridRefHonor"
              id="gridHonor"
              :data-source="gajiListStore.dataSourceGajiHonorHistory"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :focused-row-enabled="true"
              @option-changed="onPageChanged($event, 'gridRefHonor')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              @row-updating="onRowUpdating($event, 'gridRefHonor')"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefHonor')
              "
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <DxExport :enabled="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
              />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />

              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefHonor')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>

              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />

              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #headerTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderExpand"
                  />
                  <span style="margin-left: 8px">Pekerjaan</span>
                </div>
              </template>
              <template #headerGajiTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpandedGaji ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderGajiExpand"
                  />
                  <span style="margin-left: 8px">Gaji</span>
                </div>
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="200"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                data-field="tgl_gaji"
                caption="Periode Penggajian"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :filter-operations="filterOperations"
                :fixed="true"
                fixed-position="left"
              />

              <DxColumn
                :allow-hiding="false"
                class="noteditable"
                data-field="golongans_nama"
                caption="Gol."
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.getGolonganSource().value,
                }"
              />
              <DxColumn
                caption="Pekerjaan"
                header-cell-template="headerTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="cabangs_nama"
                  caption="Cabang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.cabangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="units_nama"
                  caption="Unit"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.unitSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="jabatans_nama"
                  caption="Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.jabatanSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bagians_nama"
                  caption="Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bagians_nama"
                  caption="Sub Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bidangs_nama"
                  caption="Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bidangSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bidangs_nama"
                  caption="Sub Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="seksis_nama"
                  caption="Seksi"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.seksiSource }"
                  :visible="isExpanded"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="simpeg_pegawais_tgl_mulai_bekerja"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-type="number"
                data-field="masa_kerja"
                caption="Masa Kerja"
                :customize-text="commonFunction.appendTahun"
                :allow-hiding="false"
              />
              <DxColumn
                caption="Gaji"
                header-cell-template="headerGajiTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="honor_umk_jml"
                  caption="Honor (UMK)"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="kenaikan_masa_kerja"
                  caption="Kenaikan Masa Kerja"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kesehatan"
                  caption="Tunj. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkk"
                  caption="Premi JKK"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkm"
                  caption="Premi JKM"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />

                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  data-field="absen_bulans_tidak_hadir"
                  caption="Jml Tdk Hadir"
                  class="noteditable"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />

                <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_5_persen"
                  caption="Pot. Tdk Hadir"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="jml_bruto"
                  caption="Jml Bruto"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_kesehatan"
                  caption="Pot. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_dua_persen"
                  caption="Pot. BPJS TK 2%"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="ifg_mandiri"
                  caption="Pot. IFG Mandiri"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
              </DxColumn>

              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
                :min-width="150"
                class="noteditable-ket"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="true"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>

              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>
              <!-- <DxColumn
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
                class="noteditable-ket"
              ></DxColumn> -->

              <DxSummary>
                <DxTotalItem
                  column="honor_umk_jml"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="kenaikan_masa_kerja"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkk"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkm"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="absen_bulans_tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_dua_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="ifg_mandiri"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
          <template #tKontrak>
            <DxDataGrid
              ref="gridRefKontrak"
              :data-source="gajiListStore.dataSourceGajiKontrakHistory"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefKontrak')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              @row-updating="onRowUpdating($event, 'gridRefKontrak')"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefKontrak')
              "
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <DxExport :enabled="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
              />

              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefKontrak')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>

              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />

              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #headerTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderExpand"
                  />
                  <span style="margin-left: 8px">Pekerjaan</span>
                </div>
              </template>
              <template #headerGajiTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpandedGaji ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderGajiExpand"
                  />
                  <span style="margin-left: 8px">Gaji</span>
                </div>
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="simpeg_pegawais_nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                :min-width="200"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                data-field="tgl_gaji"
                caption="Periode Penggajian"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :filter-operations="filterOperations"
                :fixed="true"
                fixed-position="left"
              />

              <DxColumn
                :allow-hiding="false"
                class="noteditable"
                data-field="golongans_nama"
                caption="Gol."
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.getGolonganSource().value,
                }"
              />
              <DxColumn
                caption="Pekerjaan"
                header-cell-template="headerTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="cabangs_nama"
                  caption="Cabang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.cabangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="units_nama"
                  caption="Unit"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.unitSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="jabatans_nama"
                  caption="Jabatan"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.jabatanSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bagians_nama"
                  caption="Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bagianSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bagians_nama"
                  caption="Sub Bagian"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBagianSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="bidangs_nama"
                  caption="Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.bidangSource }"
                  :visible="isExpanded"
                />

                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="sub_bidangs_nama"
                  caption="Sub Bidang"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.subBidangSource }"
                  :visible="isExpanded"
                />
                <DxColumn
                  class="noteditable"
                  :allow-hiding="false"
                  data-field="seksis_nama"
                  caption="Seksi"
                  :allowHeaderFiltering="true"
                  :header-filter="{ dataSource: commonStore.seksiSource }"
                  :visible="isExpanded"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="simpeg_pegawais_tgl_mulai_bekerja"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allow-hiding="false"
              />

              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable"
                data-type="number"
                data-field="masa_kerja"
                caption="Masa Kerja"
                :customize-text="commonFunction.appendTahun"
                :allow-hiding="false"
              />
              <DxColumn
                caption="Gaji"
                header-cell-template="headerGajiTemplate"
                :allow-hiding="false"
                :allowHeaderFiltering="false"
                :min-width="150"
              >
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="honor_umk_jml"
                  caption="Honor (UMK)"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="kenaikan_masa_kerja"
                  caption="Kenaikan Masa Kerja"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="tun_kesehatan"
                  caption="Tunj. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkk"
                  caption="Premi JKK"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  class="noteditable-gaji"
                  data-type="number"
                  data-field="premi_jkm"
                  caption="Premi JKM"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  data-field="absen_bulans_tidak_hadir"
                  caption="Jml Tdk Hadir"
                  class="noteditable"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_5_persen"
                  caption="Pot. Tdk Hadir"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="tun_bpjs_tk_satu_sembilanbelas_persen"
                  caption="Tunj. BPJS TK 1.19%"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="jml_bruto"
                  caption="Jml Bruto"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_kesehatan"
                  caption="Pot. Kesehatan"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="pot_bpjs_tk_satu_sembilanbelas_persen"
                  caption="Pot. BPJS TK 1.19%"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
                <DxColumn
                  :allowHeaderFiltering="false"
                  data-type="number"
                  class="noteditable"
                  data-field="ifg_mandiri"
                  caption="Pot. IFG Mandiri"
                  :customize-text="commonFunction.formatNumberWithDots"
                  :allow-hiding="false"
                  :visible="isExpandedGaji"
                />
              </DxColumn>

              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                :min-width="150"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="true"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>

              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>
              <!-- <DxColumn
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn> -->
              <DxSummary>
                <DxTotalItem
                  column="honor_umk_jml"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="kenaikan_masa_kerja"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkk"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="premi_jkm"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="absen_bulans_tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_bpjs_tk_satu_sembilanbelas_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_satu_sembilanbelas_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="ifg_mandiri"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>

          <template #tDewas>
            <DxDataGrid
              ref="gridRefDewas"
              :data-source="dewasGajiListStore.dataSourceDewasGajiDewasHistory"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefDewas')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              @row-updating="onRowUpdating($event, 'gridRefDewas')"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefDewas')
              "
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <DxExport :enabled="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
              />

              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefDewas')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>

              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />

              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #headerTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderExpand"
                  />
                  <span style="margin-left: 8px">Pekerjaan</span>
                </div>
              </template>
              <template #headerGajiTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpandedGaji ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderGajiExpand"
                  />
                  <span style="margin-left: 8px">Gaji</span>
                </div>
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="dewas_nama"
                caption="Nama"
                :fixed="true"
                fixed-position="left"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                :min-width="200"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                data-field="tgl_gaji"
                caption="Periode Penggajian"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :filter-operations="filterOperations"
                :fixed="true"
                fixed-position="left"
              />

              <DxColumn
                class="noteditable"
                data-field="dewas_pphs_ptkp"
                caption="PTKP"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusPtkpSource }"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable"
                data-field="dewas_pphs_ter"
                caption="TER PPH 21(%)"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                data-type="number"
              />

              <DxColumn
                class="noteditable"
                :allow-hiding="false"
                data-field="jabatans_nama"
                caption="Jabatan"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.jabatanDewasSource }"
              />

              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-gaji"
                data-type="number"
                data-field="uang_jasa"
                caption="Uang Jasa"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
              />

              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-gaji"
                data-type="number"
                data-field="pot_pph"
                caption="Pot. PPH"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
              />

              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                :min-width="150"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="true"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>

              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>

              <DxSummary>
                <DxTotalItem
                  column="uang_jasa"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>

          <template #tDewasSekre>
            <DxDataGrid
              ref="gridRefDewasSekre"
              :data-source="dewasGajiListStore.dataSourceDewasGajiSekreHistory"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefDewasSekre')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              @row-updating="onRowUpdating($event, 'gridRefDewasSekre')"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @context-menu-preparing="
                onContextMenuPreparing($event, 'gridRefDewasSekre')
              "
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              :height="gridHeight"
            >
              <DxExport :enabled="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
              />

              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxHeaderFilter :visible="true" />
              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefDewasSekre')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>

              <DxColumnFixing :enabled="true" />

              <DxColumn
                class="noteditable"
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />

              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #headerTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpanded ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderExpand"
                  />
                  <span style="margin-left: 8px">Pekerjaan</span>
                </div>
              </template>
              <template #headerGajiTemplate>
                <div
                  class="small-button-container"
                  style="display: inline-flex; align-items: center"
                >
                  <DxButton
                    :icon="isExpandedGaji ? 'chevrondown' : 'chevronnext'"
                    @click="toggleHeaderGajiExpand"
                  />
                  <span style="margin-left: 8px">Gaji</span>
                </div>
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="dewas_nama"
                caption="Nama"
                :fixed="true"
                fixed-position="left"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                :min-width="200"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                data-field="tgl_gaji"
                caption="Periode Penggajian"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :customize-text="commonFunction.formatIsoDateToMonthYear"
                :filter-operations="filterOperations"
                :fixed="true"
                fixed-position="left"
              />

              <DxColumn
                class="noteditable"
                data-field="dewas_pphs_ptkp"
                caption="PTKP"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusPtkpSource }"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable"
                data-field="dewas_pphs_ter"
                caption="TER PPH 21(%)"
                :allowHeaderFiltering="false"
                :allow-hiding="false"
                data-type="number"
              />

              <DxColumn
                class="noteditable"
                :allow-hiding="false"
                data-field="jabatans_nama"
                caption="Jabatan"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.jabatanDewasSource }"
              />

              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-gaji"
                data-type="number"
                data-field="honor"
                caption="Honor"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
              />

              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-gaji"
                data-type="number"
                data-field="pot_pph"
                caption="Pot. PPH"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
              />

              <DxColumn
                :allowHeaderFiltering="false"
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                :customize-text="commonFunction.formatNumberWithDots"
                :allow-hiding="false"
              />
              <DxColumn
                :allowHeaderFiltering="false"
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                :min-width="150"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn>
              <DxColumn
                :allowHeaderFiltering="true"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
                :header-filter="{
                  dataSource: commonStore.editedByUserSource,
                }"
                :allow-filtering="false"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.editedByUserStore"
                />
              </DxColumn>

              <DxColumn
                caption="Dibuat oleh"
                class="noteditable"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                class="noteditable"
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
              <DxColumn
                class="noteditable"
                caption="Disetujui oleh"
                :allowHeaderFiltering="false"
                data-field="approved_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>

              <DxSummary>
                <DxTotalItem
                  column="honor"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
        </DxTabPanel>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.class-tandai-salah {
  background-color: rgba(243, 158, 108);
  /* Other styles as needed */
}
.class-tandai-salah td {
  background-color: rgba(
    243,
    158,
    108,
    0.5
  ); /* Ensures cells also have the background */
}
.dx-datagrid-rowsview .dx-row {
  height: 50px; /* Set a custom height for rows */
  padding-top: 10px; /* Optional: Add padding for additional spacing */
  padding-bottom: 10px;
}
</style>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import { useGajiListStore } from "@/stores/views/gaji-list-store";
import { useDewasGajiListStore } from "@/stores/views/dewas-gaji-list-store";
import DxTextBox from "devextreme-vue/text-box";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import { useCommonStore } from "@/stores/utility/common-store2";
import router from "@/router";
import can from "@/haspermission";
import DxTabPanel from "devextreme-vue/tab-panel";
import DxButton from "devextreme-vue/button";

import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxSummary,
  DxTotalItem,
  DxColumnChooser,
  DxColumnChooserSearch,
  DxColumnChooserSelection,
  DxPosition,
  DxHeaderFilter,
  DxScrolling,
  DxLookup,
} from "devextreme-vue/data-grid";
// import { toHandlerKey } from "vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { DateTime } from "luxon";

import * as commonFunction from "@/utils/common-function.js";
const tabSource = [
  {
    id: 1,
    text: "Direksi",
    template: "tDireksi",
  },
  {
    id: 2,
    text: "Pegawai Tetap",
    template: "tTetap",
  },
  {
    id: 3,
    text: "Calon Pegawai",
    template: "tCapeg",
  },
  {
    id: 4,
    text: "Pekerja Honor",
    template: "tHonor",
  },
  {
    id: 5,
    text: "Pekerja Kontrak",
    template: "tKontrak",
  },
  {
    id: 6,
    text: "Dewan Pengawas",
    template: "tDewas",
  },
  {
    id: 7,
    text: "Sekretariat Dewan Pengawas",
    template: "tDewasSekre",
  },
];

export default {
  components: {
    // confirm,

    DxTabPanel,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxPager,
    DxColumnFixing,
    DxExport,
    DxToolbar,
    DxItem,
    DxSummary,
    DxTotalItem,
    DxButton,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxColumnChooserSelection,
    DxPosition,
    DxHeaderFilter,
    DxScrolling,
    DxLookup,
    DxTextBox,
    DxValidator,
    DxRequiredRule,
    LogPopupTemplate,

    // confirm,
  },
  setup() {
    const gajiListStore = useGajiListStore();
    const dewasGajiListStore = useDewasGajiListStore();
    const commonStore = useCommonStore();
    const masaKerjaRange = Array.from({ length: 34 }, (_, i) => i);
    return {
      dewasGajiListStore,
      gajiListStore,
      commonFunction,
      masaKerjaRange,
      commonStore,
    };
  },

  data() {
    return {
      cariNamaPegawai: null,
      direksiStore: null,
      isExpanded: true,
      isExpandedGaji: true,

      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",

      rowClickData: null,
      rowClickRef: null,
      pegawaiIdClick: null,

      calendarMonthYear: {
        maxZoomLevel: "year",
        minZoomLevel: "century",
      },

      popupWarningVisible: false,
      popupWarningContent: null,
      popupWarningTitle: null,
      opacitySalah: 1, // Initial opacity value
      opacityApproved: 1, // Initial opacity value
      opacityJmlPegawai: 1, // Initial opacity value
      notif: [],
      logPopupRef: null,
      periodeTitle: null,
      mode: "select",
      searchEnabled: true,
      allowSelectAll: true,
      selectByClick: true,
      recursive: true,
      editorOptions: { placeholder: "Search column" },

      router: router,
      statusButtonIcon: null,
      statusButtonType: null,
      numberingPageSize: 100,
      numberingPageNumber: 0,
      tabPanelIndex: 0,
      loop: false,
      animationEnabled: true,
      swipeEnabled: false,
      tabSource: tabSource,
      popupRefreshAllGajiVisible: false,
      popupLoadingVisible: false,
      editedSource: [
        { val: true, nama: "Diedit user" },
        { val: false, nama: "Dibuat sistem" },
      ],
      statusPtkpSource: [
        { nama: "" },
        { nama: "TK" },
        { nama: "K0" },
        { nama: "K1" },
        { nama: "K2" },
        { nama: "K3" },
      ],

      filterValue: [],

      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      oneditorpreparing: function (e) {
        if (e.dataField === "tgl_gaji") {
          e.editorOptions.calendarOptions = {
            minZoomLevel: "year",
            maxZoomLevel: "year",
            displayFormat: "MM/yyyy",
            type: "month",
          };
        }
      },
      calculateFilterMK: function (
        filterValue,
        selectedFilterOperation,
        target,
      ) {
        if (selectedFilterOperation === "contains" && target == "filterRow") {
          const currentDate = DateTime.now();
          const mkDate = currentDate.minus({ years: filterValue });
          var filterExpression = [
            "year(" +
              this.dataField +
              ") ge " +
              mkDate.year +
              " and " +
              "year(" +
              this.dataField +
              ") le " +
              currentDate.year,
          ];

          return filterExpression;
        }
      },
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target,
      ) {
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterRow") {
          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterRow") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(" +
              column.dataField +
              ") lt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterRow") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(" +
              column.dataField +
              ") gt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(" +
              column.dataField +
              ") ge " +
              bulan1 +
              " and year(" +
              column.dataField +
              ") ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(" +
              column.dataField +
              ") le " +
              bulan2 +
              " and year(" +
              column.dataField +
              ") le " +
              filterValue[1].getFullYear(),
          ];
          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },

      cancelButtonOptions: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupWarningVisible = false;
          this.popupRefreshAllGajiVisible = false;
        },
      },
      // popupWarningClicked: null,
      popupWarningStatusId: null,
      confirmButtonRefreshAllGajiOptions: {
        text: "Hitung Ulang Seluruh Gaji",
        onClick: () => {
          // this.popupRefreshAllGajiVisible = false; sementara disable
          this.refreshAllGaji();
        },
      },
      confirmButtonOptionsWarning: {
        text: "Confirm",
        onClick: () => {
          this.popupWarningVisible = false;
          if (this.popupWarningStatusId === "refreshAllGajiConfirm") {
            this.popupRefreshAllGajiVisible = true;

            return;
          }
          if (this.popupWarningStatusId === "refreshGajiPerPegawaiConfirm") {
            this.refreshGajiPerPegawai();
            return;
          }

          if (this.popupWarningStatusId === 3) {
            const updatedData = {
              status_gaji: true,
              tandai_salah: false,
              gaji_periode_id: this.gajiPeriodeId,
            };
            this.sinkronAllGaji(updatedData);
          }
          this.updateStatusGajiPeriode(this.popupWarningStatusId);
          // if (typeof this[this.popupWarningClicked] === "function")
          //   this[this.popupWarningClicked]();
        },
      },
    };
  },
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  async created() {
    await this.commonStore.preloadStores();
  },

  async mounted() {
    this.getUrlFilter();
  },
  methods: {
    getUrlFilter() {
      if (this.$route.query.filter) {
        let filter = this.$route.query.filter;
        if (!isNaN(filter[2]) && typeof +filter[2] === "number") {
          // alert("The third element is a number");
          filter[2] = parseInt(this.$route.query.filter[2]);
          filter = [[filter[0], filter[1], filter[2]]];
        }

        this.addFilterToCustomStore(filter);
        this.addFilterToCustomStoreDewas(filter);
      }
    },

    addFilterToCustomStore(filterValue = null) {
      if (filterValue === null) {
        this.gajiListStore.dataSourceGajiDireksiHistory.filter(
          ["gajis_pegawai_status_id", "=", 1], // Original filter
        );
        this.gajiListStore.dataSourceGajiTetapHistory.filter(
          ["gajis_pegawai_status_id", "=", 2], // Original filter
        );
        this.gajiListStore.dataSourceGajiCapegHistory.filter(
          ["gajis_pegawai_status_id", "=", 3], // Original filter
        );
        this.gajiListStore.dataSourceGajiHonorHistory.filter(
          ["gajis_pegawai_status_id", "=", 4], // Original filter
        );
        this.gajiListStore.dataSourceGajiKontrakHistory.filter(
          ["gajis_pegawai_status_id", "=", 5], // Original filter
        );
      } else {
        this.gajiListStore.dataSourceGajiDireksiHistory.filter([
          ["gajis_pegawai_status_id", "=", 1], // Original filter
          "and",
          ...filterValue,
        ]);
        this.gajiListStore.dataSourceGajiTetapHistory.filter([
          ["gajis_pegawai_status_id", "=", 2], // Original filter
          "and",
          ...filterValue,
        ]);
        this.gajiListStore.dataSourceGajiCapegHistory.filter([
          ["gajis_pegawai_status_id", "=", 3], // Original filter
          "and",
          ...filterValue,
        ]);
        this.gajiListStore.dataSourceGajiHonorHistory.filter([
          ["gajis_pegawai_status_id", "=", 4], // Original filter
          "and",
          ...filterValue,
        ]);
        this.gajiListStore.dataSourceGajiKontrakHistory.filter([
          ["gajis_pegawai_status_id", "=", 5], // Original filter
          "and",
          ...filterValue,
        ]);
      }
    },

    addFilterToCustomStoreDewas(filterValue = null) {
      if (filterValue === null) {
        this.dewasGajiListStore.dataSourceDewasGajiDewasHistory.filter(
          ["dewas_is_dewas", "=", true], // Original filter
        );
        this.dewasGajiListStore.dataSourceDewasGajiSekreHistory.filter(
          ["dewas_is_dewas", "=", false], // Original filter
        );
      } else {
        this.dewasGajiListStore.dataSourceDewasGajiDewasHistory.filter(
          [["dewas_is_dewas", "=", true], "and", ...filterValue], // Original filter
        );
        this.dewasGajiListStore.dataSourceDewasGajiSekreHistory.filter(
          [["dewas_is_dewas", "=", false], "and", ...filterValue], // Original filter
        );
      }
    },

    cariPegawai(e) {
      const result = e.validationGroup.validate();

      if (!result.isValid) return 0;
      const filterValue = [
        ["simpeg_pegawais_nama", "contains", this.cariNamaPegawai],
      ];

      this.addFilterToCustomStore(filterValue);
      this.addFilterToCustomStoreDewas([
        ["dewas_nama", "contains", this.cariNamaPegawai],
      ]);

      // const refDireksi = this.$refs["gridRefDireksi"];
      this.reloadCustomStore();

      // this.$refs["gridRefDireksi"].instance.getDataSource().filter(filterValue);
    },

    reloadCustomStore() {
      if (
        this.$refs["gridRefDireksi"] &&
        this.$refs["gridRefDireksi"].instance
      ) {
        this.$refs["gridRefDireksi"].instance.getDataSource().reload();
      }
      if (this.$refs["gridRefTetap"] && this.$refs["gridRefTetap"].instance) {
        this.$refs["gridRefTetap"].instance.getDataSource().reload();
      }
      if (this.$refs["gridRefCapeg"] && this.$refs["gridRefCapeg"].instance) {
        this.$refs["gridRefCapeg"].instance.getDataSource().reload();
      }
      if (this.$refs["gridRefHonor"] && this.$refs["gridRefHonor"].instance) {
        this.$refs["gridRefHonor"].instance.getDataSource().reload();
      }
      if (
        this.$refs["gridRefKontrak"] &&
        this.$refs["gridRefKontrak"].instance
      ) {
        this.$refs["gridRefKontrak"].instance.getDataSource().reload();
      }

      if (this.$refs["gridRefDewas"] && this.$refs["gridRefDewas"].instance) {
        this.$refs["gridRefDewas"].instance.getDataSource().reload();
      }

      if (
        this.$refs["gridRefDewasSekre"] &&
        this.$refs["gridRefDewasSekre"].instance
      ) {
        this.$refs["gridRefDewasSekre"].instance.getDataSource().reload();
      }
    },

    resetFilter() {
      // if (this.cariNamaPegawai === null || this.cariNamaPegawai === "") {

      //   return;
      // }
      // if (!this.route.query.filter) {
      //   return;
      // }
      this.addFilterToCustomStore();
      this.addFilterToCustomStoreDewas();
      this.cariNamaPegawai = null;

      this.reloadCustomStore();
    },

    onContextMenuPreparing(e, gridRef) {
      if (e.target == "content") {
        // e.items can be undefined
        if (!e.items) e.items = [];

        // e.items.push({
        //   text: "Lihat Detail Pegawai",
        //   icon: "user",
        //   onItemClick: () => {
        //     this.detailPegawai(e);
        //     // e.component.editRow(e.component.getRowIndexByKey(item));
        //   },
        // });
        // e.items.push({
        //   text: "Lihat Absensi",
        //   icon: "event",
        //   onItemClick: () => {
        //     this.detailAbsen(e);
        //     // e.component.editRow(e.component.getRowIndexByKey(item));
        //   },
        // });

        if (gridRef === "gridRefDewas" || gridRef === "gridRefDewasSekre") {
          let temp = "";
          if (gridRef === "gridRefDewasSekre") temp = "Sekretariat ";
          e.items.push({
            text: "Lihat Detail " + temp + "Dewan Pengawas",
            icon: "user",
            onItemClick: () => {
              this.detailPegawai(e, "dewas-detail");
            },
          });
          e.items.push({
            text: "Log Perubahan Data",
            icon: "clock",
            onItemClick: () => {
              e.itemData = "Log Perubahan Data";
              this.$refs.logPopup.showBySubject(e.row.data.id, "DewasGaji");
            },
          });
        } else {
          e.items.push({
            text: "Lihat Detail Pegawai",
            icon: "user",
            onItemClick: () => {
              this.detailPegawai(e);
              // e.component.editRow(e.component.getRowIndexByKey(item));
            },
          });
          e.items.push({
            text: "Lihat Absensi",
            icon: "event",
            onItemClick: () => {
              this.detailAbsen(e);
              // e.component.editRow(e.component.getRowIndexByKey(item));
            },
          });
          e.items.push({
            text: "Log Perubahan Data",
            icon: "clock",
            onItemClick: () => {
              e.itemData = "Log Perubahan Data";
              this.$refs.logPopup.showBySubject(e.row.data.id, "Gaji");
            },
          });
        }
      }
    },
    toggleHeaderExpand() {
      this.isExpanded = !this.isExpanded;
    },
    toggleHeaderGajiExpand() {
      this.isExpandedGaji = !this.isExpandedGaji;
    },

    formattedDate(tgl) {
      const jsDate = new Date(tgl);
      const dt = DateTime.fromJSDate(jsDate).setZone("Asia/Makassar");
      const convert = dt
        .setLocale("id")
        .toFormat("cccc dd MMMM yyyy HH:mm:ss 'WITA'");
      const originalDate = DateTime.fromFormat(
        convert,
        "cccc dd MMMM yyyy HH:mm:ss 'WITA'",
        { locale: "id" },
      );

      const newDate = originalDate.plus({ hours: 8 });
      const formattedNewDate = newDate.toFormat(
        "cccc dd MMMM yyyy HH:mm:ss 'WITA'",
      );
      return formattedNewDate;
    },
    templateUpdateByUser(data) {
      if (data.data.editedByUser) {
        return (
          data.data.editedByUser.name +
          ", " +
          this.formattedDate(data.data.updated_at)
        );
      }
      return;
    },

    can,
    refreshDatagrid(gridRef) {
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    detailPegawaiAsli(e) {
      // this.$router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: e.row.data.pegawai_id },
      // });
      const url = this.$router.resolve({
        name: "pegawai-detail-custom",
        query: { id: e.row.data.pegawai_id },
      }).href;
      window.open(url, "_blank");
    },
    detailPegawai(e, url = null) {
      // const url = this.$router.resolve({
      //   name: "pegawai-detail-custom",
      //   query: { id: e.row.data.pegawai_id },
      // }).href;
      // window.open(url, "_blank");

      const routeConfig = url
        ? {
            name: url,
            query: { id: e.row.data.dewas_id },
          }
        : {
            name: "pegawai-detail-custom",
            query: { id: e.row.data.pegawai_id },
          };

      const resolvedUrl = this.$router.resolve(routeConfig).href;
      window.open(resolvedUrl, "_blank");
    },

    detailAbsen(e) {
      const url = this.$router.resolve({
        name: "absen-list-custom",
        query: {
          filter: ["absen_bulans_id", "=", e.row.data.absen_bulan_id],
        },
      }).href;
      window.open(url, "_blank");
    },

    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },

    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Gaji");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Gaji " + this.tabSource[this.tabPanelIndex].text + ".xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
